import { ContextType, FileType } from "../../../types/File.ts";
import { ReactNode, useEffect, useRef } from "react";
import { uploadFile } from "../../../fetch/fetch.file.ts";
import PopUp, { openModal } from "../../core/PopUp.tsx";
import { MAX_FILE_SIZE } from "../../../const/enviroment.ts";
import { ERROR } from "../../../types/Error/Errors.ts";

const ImageUpload = ({
  context,
  contextId,
  file,
  onUpload,
  onError,
  children,
}: {
  context: ContextType;
  contextId: string;
  file: FileType;
  onUpload: (file: FileType) => void;
  onError: (file: FileType) => void;
  children: (local: boolean) => ReactNode;
}) => {
  const uploaded = useRef("");
  useEffect(() => {
    upload(file);
  }, [file]);

  const upload = async (newFile: FileType) => {
    if (!newFile.local || uploaded.current === file.basename) return;
    uploaded.current = newFile.basename;

    const response = await fetch(newFile.basename);
    const blob = await response.blob();
    const upload = new File([blob], "filename.jpg", { type: blob.type });
    const result = await uploadFile(upload, context, contextId);
    if (!result.ok) {
      switch (result.error) {
        case ERROR.FILE_SIZE_LIMIT: {
          openModal("file-size");
          URL.revokeObjectURL(newFile.basename);
          onError(file);
        }
      }
      return;
    }
    onUpload(result.value);
  };

  return (
    <div>
      <PopUp id={"file-size"} title="Bild braucht zu viel Speicherplatz.">
        Das Bild darf maximal {MAX_FILE_SIZE} MB sein.
      </PopUp>
      {children(!!file.local)}
    </div>
  );
};
export default ImageUpload;
